import { statuses } from 'keys'

const useTabs = () => {
    const { backToTranscription, transcriptionComplete, transcriptionInProgress, inProgress, brokenFile, wordsComplete, wordsInProgress, uploaded, backToMarking, audioCuttingComplete, audioCuttingInProgress } = statuses

    return [
        {
            id: 0,
            label: "ממתינים לתעתוק",
            filters: {
                status: [inProgress, backToTranscription],
                sub_status: audioCuttingComplete
            }
        },
        {
            id: 1,
            label: "בתעתוק",
            filters: {
                status: [inProgress],
                sub_status: transcriptionInProgress
            }
        },
        {
            id: 2,
            label: "תעתוק הסתיים",
            filters: {
                status: [inProgress],
                sub_status: transcriptionComplete
            }
        },
        {
            id: 3,
            label: "אודיו לא תקין",
            filters: {
                status: [brokenFile],
                sub_status: ""
            }
        }
    ]

}



export default useTabs
